import { render, staticRenderFns } from "./TikHubOperatorSettings.vue?vue&type=template&id=64c61dca&scoped=true&"
import script from "./TikHubOperatorSettings.vue?vue&type=script&lang=js&"
export * from "./TikHubOperatorSettings.vue?vue&type=script&lang=js&"
import style0 from "./TikHubOperatorSettings.vue?vue&type=style&index=0&id=64c61dca&prod&scoped=true&lang=css&"
import style1 from "./TikHubOperatorSettings.vue?vue&type=style&index=1&id=64c61dca&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c61dca",
  null
  
)

export default component.exports